import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const PublicRoute = ({ children }) => {
  const { user } = useUser() || {};
  const token = localStorage.getItem('token');
  
  // If token exists, redirect based on role
  if (token) {
    if (user?.role === 'superAdmin') {
      return <Navigate to="/dashboard" replace />;
    }
    // Redirect user/companyAdmin to their company projects page
    if ((user?.role === 'user' || user?.role === 'companyAdmin')) {
      const companyId = user?.company?.id || user?.assetId;
      if (companyId) {
        return <Navigate to={`/company/${companyId}/projects`} replace />;
      }
    }
    return <Navigate to="/companies" replace />;
  }
  
  // If no token, render the public component (login, forgot password, etc.)
  return children;
};

export default PublicRoute;
